import * as React from 'react';
import QRCode from 'react-qr-code';
import { cn } from '@/utils/utils';

const QUIET_ZONE = 'bg-[#ffffff]'; // theme-exempt: scanners need a QR code's quiet zone white, so no theme token can draw it

/** The quiet zone's width: sm beside other content, md in a card, lg on its own in a dialog. */
const FRAMES = { sm: 'p-2', md: 'p-3', lg: 'p-6' } as const;

interface QrCodeProps {
  /** What it encodes: a link. */
  value: string;
  /** The code's width in pixels, inside its frame. */
  size: number;
  /** Shrinks to fit a narrower container instead of keeping its size. */
  fluid?: boolean;
  frame?: keyof typeof FRAMES;
  className?: string;
}

/** A QR code on its white quiet zone, the same in every theme. Its ref is the frame, which downloadQrPng saves the code from. */
export const QrCode = React.forwardRef<HTMLDivElement, QrCodeProps>(({ value, size, fluid = false, frame = 'md', className }, ref) => (
  <div ref={ref} className={cn('rounded-lureo-radius border-lureo-border-width border-lureo-line', QUIET_ZONE, FRAMES[frame], className)}>
    <QRCode value={value} size={size} level="M" className="block" style={fluid ? { height: 'auto', maxWidth: '100%', width: '100%' } : undefined} />
  </div>
));
QrCode.displayName = 'QrCode';
